<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-home" :label="!isSmallerScreen ? 'Homepage' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <homepage />
      </div>
    </vs-tab>

     <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Testimonials' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <testimonials />
      </div>
    </vs-tab>

  </vs-tabs>
</template>

<script>
import homepage from './homepage/homepage.vue'
import testimonials from './testimonials/testimonials.vue'

export default {
  components: {
    homepage,
    testimonials
  },
  data () {
    return {

    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
